import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LoadingContext } from "src/M_Components";

export const InvoiceVat = ({ dataState }) => {
  const { t } = useTranslation()
  const ctx = useContext(LoadingContext)

  return (
    <div style={{ marginBottom: "20px", marginTop: "20px", display: "flex", flexWrap: "wrap" }}>
      <div style={{ display: "flex", alignItems: "center", marginRight: "30px", marginLeft: "10px" }}>
        <span style={{ color: ctx.secondaryColor, fontWeight: "bold", margin: "3px" }}>{t("TotalWithVat")}:</span>
        <span style={{ fontWeight: "normal", margin: "3px" }}>{dataState.TotalWithVat} €</span>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <span style={{ color: ctx.secondaryColor, fontWeight: "bold", margin: "3px" }}>{t("TotalWithoutVat")}:</span>
        <span style={{ fontWeight: "normal", margin: "3px" }}>{dataState.TotalWithoutVat} €</span>
      </div>
    </div>
  )
}